module.exports = __webpack_public_path__ + "img/architecture.6c94b67a.jpg";